import { createSelector } from '@ngrx/store';
import { ChatState, getChatFeatureState } from '../reducers';

const getChatActiveLoadsState = createSelector(getChatFeatureState, (state: ChatState) => state.activeLoads);

export const getSelectedLoadId = createSelector(getChatActiveLoadsState, (state) => state.selectedLoadId);
